import { Box, ListItemIcon, MenuItem, MenuList, styled } from '@mui/material';
import { NavLink } from 'components';

export const LibraryGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  height: 'calc(100vh - 72px)',
  gridTemplateRows: `1fr`,
  gridTemplateColumns: `${theme.spacing(27.5)} auto`,
  borderTop: `1px solid ${theme.palette.grey[800]}`,
  [theme.breakpoints.down('md')]: {
    gridTemplateRows: `auto 1fr`,
    gridTemplateColumns: '1fr',
  },
}));

export const LibrarySidebar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRight: `1px solid ${theme.palette.grey[800]}`,
  padding: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    background: 'none',
  },
}));

export const LibraryMenuList = styled(MenuList)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const LibraryMenuItem = styled(MenuItem)(() => ({
  padding: 0,
}));

export const LibraryNavLink = styled(NavLink)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
    fontSize: 16,
  },
}));

export const LibraryListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: 'inherit',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const LibraryContent = styled(Box)(() => ({
  height: '100%',
  overflow: 'hidden',
}));
